import React, { useState } from "react";
import LinesHandler from "./LinesHandler.js";
import CourseLine from "./CourseLine.js";
import bookSVG from "../svg/book.svg";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

const Courses = ({
  control,
  errors,
  unregister,
  setValue,
  getValues,
  trigger,
}) => {
  //START ADAPT TO NEW EXCEL : IT WONT SUPPORT MORE THAN ONE COURSE WITH THE SAME TITLE//
  const [selectedCourses, setSelectedCourses] = useState([{}]);

  const handleCourseChange = (lineId, courseTitle, remove) => {
    setSelectedCourses((prevSelectedCourses) => {
      const updatedCourses = prevSelectedCourses.filter(
        (c) => c.lineId !== lineId
      );
      if (remove) {
        return updatedCourses;
      }
      return [...updatedCourses, { lineId, courseTitle }];
    });
  };
  //END ADAPT TO NEW EXCEL : IT WONT SUPPORT MORE THAN ONE COURSE WITH THE SAME TITLE//

  return (
    <div className="main-card">
      <div className="card-title-box">
        <img className="svg-in-card-title" src={bookSVG} alt="accommodation" />
        <div className="card-title">Courses Required</div>
      </div>
      <div className="sub-card">
        <div className="mb-1">
          <LinesHandler
            lineComponent={CourseLine}
            lineType="course"
            control={control}
            errors={errors}
            unregister={unregister}
            setValue={setValue}
            getValues={getValues}
            trigger={trigger}
            selectedCourses={selectedCourses}
            handleCourseChange={handleCourseChange}
          />
          <div className="my-1">
            <div className="mb-1">
              If you have any other comments regarding courses, please share
              them below:
            </div>
            <Controller
              render={({ field }) => (
                <TextField
                  {...field}
                  error={Boolean(errors.extraCoursesComments)}
                  helperText={
                    errors.extraCoursesComments
                      ? errors.extraCoursesComments.message
                      : null
                  }
                  label="Extra Comments"
                  className="w-full"
                  multiline
                  rows={4}
                />
              )}
              name="extraCoursesComments"
              control={control}
              rules={{
                maxLength: {
                  value: 500,
                  message: "Extra comments cannot exceed 500 characters",
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Courses;
